import { LOGOUT, SET_WORKING_TIME_AGREEMENT, RESET_REPORT, SET_REPORT, SET_REPORTS, SET_EXTERNAL_REPORTS } from "../actions/types";

const INITIAL_STATE = {
    agreement: null,
    report: {
        reportID: null,
        userID: null,
        fname: null,
        lname: null,
        dateFrom: null,
        dateTo: null,
        standard: null,
        workingTime: null,
        totalOvertime: null,
        createdOn: null,
        details: []
    },
    list: [],
    externalList: []
};

const workingTimeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_WORKING_TIME_AGREEMENT:
            return {
                ...state,
                agreement: action.payload.agreement
            };
        case RESET_REPORT:
            return {
                ...state,
                report: INITIAL_STATE.report
            }
        case SET_REPORT:
            return {
                ...state,
                report: {
                    reportID: action.payload.reportID,
                    userID: action.payload.userID,
                    fname: action.payload.fname,
                    lname: action.payload.lname,
                    dateFrom: action.payload.dateFrom,
                    dateTo: action.payload.dateTo,
                    standard: action.payload.standard,
                    workingTime: action.payload.workingTime,
                    totalOvertime: action.payload.totalOvertime,
                    availableOvertime: action.payload.availableOvertime,
                    createdOn: action.payload.createdOn,
                    details: action.payload.details.map(pos => {
                        return {
                            day: pos.day,
                            totalWorkingTime: pos.totalWorkingTime,
                            availableBreakTime: pos.availableBreakTime,
                            actualBreakTime: pos.actualBreakTime,
                            overBreakTime: pos.overBreakTime,
                            actualWorkingTime: pos.actualWorkingTime,
                            overtime: pos.overtime,
                            correct: pos.correct
                        };
                    })
                }
            };
        case SET_REPORTS:
            return {
                ...state,
                list: Object.keys(action.payload).map(key => {
                    return {
                        ouID: key,
                        ouName: action.payload[key].ouName,
                        reports: action.payload[key].reports.map(report => {
                            return {
                                reportID: report.reportID,
                                userID: report.userID,
                                fname: report.fname,
                                lname: report.lname,
                                dateFrom: report.dateFrom,
                                dateTo: report.dateTo,
                                standard: report.standard,
                                workingTime: report.workingTime,
                                totalOvertime: report.totalOvertime
                            };
                        })
                    };
                })
            };
        case SET_EXTERNAL_REPORTS:
            return {
                ...state,
                externalList: Object.keys(action.payload).map(key => {
                    return {
                        externalOuID: key,
                        ouName: action.payload[key].ouName,
                        reports: action.payload[key].reports.map(report => {
                            return {
                                reportID: report.reportID,
                                userID: report.userID,
                                fname: report.fname,
                                lname: report.lname,
                                dateFrom: report.dateFrom,
                                dateTo: report.dateTo,
                                standard: report.standard,
                                workingTime: report.workingTime,
                                totalOvertime: report.totalOvertime
                            };
                        })
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default workingTimeReducer;